import styles from "./ContactCards.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faClock, faEnvelope, faUser } from "@fortawesome/free-regular-svg-icons";

const cards = [
  {
    icon: faUser,
    title: 'Bel ons',
    link: {href: 'tel:0888005707', label: '088-8005707'},
    text: 'Ook bereikbaar in het weekend',
  },
  {
    icon: faEnvelope,
    title: 'Mail ons',
    link: {href: 'mailto:krant@rouwadvertentiemaken.nl', label: 'krant@ rouwadvertentiemaken.nl'},
    text: 'Wij reageren snel',
  },
  {
    icon: faUsers,
    title: 'Persoonlijk contact',
    text: 'Eén vast contactpersoon die je begeleidt',
  },
  {
    icon: faClock,
    title: 'Ruime bereikbaarheid',
    text: 'Wij helpen je persoonlijk, ook buiten kantooruren',
  },
];

export default () => {
  return <div className={styles.cards}>
    {cards.map(card => <div key={card.title} className={styles.card}>
      <div className={'icon-circle'}><FontAwesomeIcon icon={card.icon} /></div>
      <h3>{card.title}</h3>
      {card.link && <p className={styles.link}><a href={card.link.href}>{card.link.label}</a></p>}
      <p>{card.text}</p>
    </div>)}
  </div>
}
